import React, { useState, useEffect } from 'react'
import {
    PaymentElement,
    LinkAuthenticationElement,
    useStripe, useElements, Elements
} from '@stripe/react-stripe-js';
import { loadStripe } from "@stripe/stripe-js";

import ExportApi from '../api/ExportApi';
import { useParams } from 'react-router-dom'
import { toast } from "react-toastify";
import { Button } from 'react-bootstrap';
const StripeElement = (props) => {
    const params = useParams()
    const [clientSecret, setClientSecret] = useState()
    const [paymentId, setPaymentId] = useState()
    const [cardEmail, setCardEmail] = useState('');
    const [stripePromise, setStripePromise] = useState(null);


    const appearance = {
        theme: 'stripe',
    };

    const options = {
        clientSecret,
        appearance,
        layout: {
            type: 'tabs',
            defaultCollapsed: false,
        }
    };

    // useEffect(() => {
    //     ExportApi.handleCardDetails(JSON.parse(localStorage.getItem("tokenuser"))?.id).then((resp) => {
    //         setClientSecret(resp?.data.data.data.client_secret);
    //         setPaymentId(resp?.data.data.id)
    //     }).catch((err) => {
    //         console.log(err);
    //     })
    // }, [])

    useEffect(() => {
        // Try to get 'tokenuser' and check if it's available, otherwise fallback to 'admin'
        const userId = JSON.parse(localStorage.getItem("tokenuser"))?.id || JSON.parse(localStorage.getItem("admin"))?.id;
    
        if (userId) {
            ExportApi.handleCardDetails(userId).then((resp) => {
                setClientSecret(resp?.data.data.data.client_secret);
                setPaymentId(resp?.data.data.id);
            }).catch((err) => {
                console.log(err);
            });
        } else {
            console.log("No user or admin found in localStorage");
        }
    }, []);
    useEffect(() => {
        ExportApi.get_stripe_publ_key()
          .then((resp) => {
            const stripeKey = resp?.data?.stripeKey;
            const stripeInstance = loadStripe(stripeKey);
            setStripePromise(stripeInstance);
          })
          .catch((err) => {
            console.log("Stripe key error", err);
          });
      }, []);

    // const handleSingleUserData = () => {
    //     ExportApi.getSingleUserData(JSON.parse(localStorage.getItem("tokenuser"))?.id)
    //         .then((resp) => {
    //             let Data = resp.data.data;
    //             setCardEmail(Data.email);
    //         })
    //         .catch((err) => console.log(err));
    // };
    const handleSingleUserData = () => {
      
        const userId = JSON.parse(localStorage.getItem("tokenuser"))?.id || JSON.parse(localStorage.getItem("admin"))?.id;
    
        if (userId) {
            ExportApi.getSingleUserData(userId)
                .then((resp) => {
                    let Data = resp.data.data;
                    setCardEmail(Data.email);
                })
                .catch((err) => console.log(err));
        } else {
            console.log("No user or admin found in localStorage");
        }
    };
    

    useEffect(() => {
        handleSingleUserData()
    }, [])
    return (
        <div>
            {clientSecret && (
                <Elements stripe={stripePromise} options={options}>
                    <CheckoutForm clientSecret={clientSecret} paymentId={paymentId} id={props.productId} cardBrand={props.cardBrand} email={cardEmail} />
                </Elements>
            )}
        </div>
    )
}
function CheckoutForm(props) {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);


 

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) {
            return;
        }
        setIsLoading(true);
        const { error } = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: window.location.href,
            },
        });

        if (error) {
            if (error.type === 'card_error' || error.type === 'validation_error') {
                toast.error(error?.message)
                setMessage("card_error");
            } else {
                setMessage('An unexpected error occurred.');
            }
        }
        setIsLoading(false);
    };


    useEffect(() => {
        if (!stripe) {
            return;
        }
        let clientSecret = props.clientSecret
        if (!clientSecret) {
            return;
        }

        stripe.retrieveSetupIntent(clientSecret).then(({ setupIntent }) => {
            switch (setupIntent.status) {
                case 'succeeded':
                    setMessage('Success! Your payment method has been saved.');
                    break;

                case 'processing':
                    setMessage("Processing payment details. We'll update you when processing is complete.");
                    break;

                case 'requires_payment_method':
                    setMessage('Failed to process payment details. Please try another payment method.');
                    break;
            }
        });
    }, [stripe]);

    const paymentElementOptions = {
        layout: "tabs"
    }


    let email = props.email;
    const getOptions = {
        defaultValues: {
            email: email
        }
    }


    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <LinkAuthenticationElement
                id="link-authentication-element"
                options={getOptions}
            />
            <PaymentElement id="payment-element" options={paymentElementOptions} />
            {
                props?.cardBrand && (
                    <p className='my-3' style={{color: "grey"}}>
                        <span style={{color : "black"}}>NOTE:</span> If you update your credit card, any existing bids will still be charged to your old card. Only new bids placed after updating your card will use the new payment method. If you would like to use your new card for all purchases, please delete all existing bids and make new bids.
                    </p>
                )
            }
            <button className='btn btn-primary' disabled={isLoading || !stripe || !elements} id="submit">
                <span id="button-text">
                    {isLoading ? <div className="spinner" id="spinner"></div> : "Add Payment Method"}
                </span>
            </button>
        </form>
    );
}

export default StripeElement